/**
 * 
 * 首页、产品列表页 两个页面数据共享
 */

let initState = {
  isDiff: '',
  time: [],
  pickTime: '',
  dropTime: '',
  pickupInfo: {},
  dropoffInfo: {}, 
}
const pickupDropoffInfo = {
    state: {
        isDiff: '', // 是否异地还车
        time: [], // 取还车日期范围缓存
        pickTime: '', // 取车时间
        dropTime: '', // 还车时间 
        pickupInfo: {}, // 取车城市和门店  首页存
        dropoffInfo: {}, // 还车城市和门店信息  首页存
    },
    mutations: {
      setIsDiff: (state, data) => {
        state.isDiff = data
      },
      setTime: (state, data) => {
          state.time = data
      },
      setPickTime: (state, data) => {
        state.pickTime = data
      },
      setDropTime: (state, data) => {
        state.dropTime = data
      },
      setPickupInfo: (state, data) => {
        state.pickupInfo = data
      },
      setDropoffInfo: (state, data) => {
        state.dropoffInfo = data
      },
      resetPickupDropoffInfo (state) {
        Object.keys(state).forEach(key => { state[key] = initState[key]})
      },
    },
    actions: {

    }
}

export default pickupDropoffInfo



// WEBPACK FOOTER //
// ./src/store/pickupDropoffInfo.js